import color from '@theme/Colors';
import React, { SVGProps } from 'react';
type Props = {} & SVGProps<SVGSVGElement>;

export default function LocationsIcon(props: Props) {
    return (
        <svg
            {...props}
            width={props.width ?? 26}
            height={props.height ?? 26}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            id="location"
            className="icon-svg-fill"
            fill={props.fill ?? color.grey600}
        >
            <g data-name="Location">
                <path d="M17,15.11a1,1,0,0,0-1-1,2,2,0,1,1,2-2,1,1,0,1,0,2,0,4,4,0,1,0-4,4A1,1,0,0,0,17,15.11Z"></path>
                <path d="M21.82,20.59l1.33-1.33a10.11,10.11,0,1,0-14.3,0l1.33,1.33C6.32,21.42,4,23,4,25c0,3.28,6,5,12,5s12-1.72,12-5C28,23,25.68,21.42,21.82,20.59ZM16,28c-6,0-10-1.81-10-3,0-.75,1.9-2.08,5.91-2.68l.85.85a1,1,0,0,0,1.41-1.41l-3.91-3.91a8.11,8.11,0,1,1,11.47,0l-6.44,6.44a1,1,0,1,0,1.41,1.41l3.39-3.39c4,.6,5.91,1.93,5.91,2.68C26,26.19,22,28,16,28Z"></path>
            </g>
        </svg>
    );
}
